(function($, HIS) {

    HIS.RISC = {
        resetRadioButtons:function (){
            for(var i=1; i<=10; i++){
                $('label[name="answer-label'+i+'"]').removeClass('active');
                $('input[name="answer'+i+'"]').removeAttr("checked");
            }       
        }
    };

})(jQuery, this.HIS);
